
import React from 'react'
import { useTheme } from '../../utils/ThemeContext';
import classes from './NumberCircle.module.scss';


export default function NumberCircle({ type, numbers, typeColor, GameName }) {
    const { theme } = useTheme();
    return (
        <>
            <div className={`${classes.NumberCircle} ${classes[type]}`} style={{ background: theme.ballsColor }}>
                {numbers && numbers.length > 1 ?
                    <>
                        <span className={classes.spanNumber + ' ' + classes.spanNumber1} data-text={numbers[0]}>{numbers && numbers[0]}</span>
                        <span className={classes.spanNumber + ' ' + classes.spanNumber2}>{numbers && numbers[1]}</span>
                    </>
                    : <span className={classes.spanNumber1}>{numbers && numbers[0]}</span>}
            </div>
            <span className={classes.gameName}>{GameName}</span>
        </>
    )
}
